<app-shared-dialog
  [title]="config.title | translate"
  [options]="dialogOptions"
  (cancel)="cancel()"
  (middle)="clearAll()"
  (confirm)="apply()"
>
  <div class="filter-form">
    <ng-container *ngFor="let section of config.sections; let sectionIndex = index">
      <div class="filter-section-title" *ngIf="section.title" [class.filter-section-title--first]="sectionIndex === 0">
        {{ section.title | translate }}
      </div>
      <ng-container *ngFor="let field of section.fields; let i = index; let isOdd = odd">

        <!-- Pair fields into .filter-row (2 per row) -->
        <div class="filter-row" *ngIf="!isOdd">
          <!-- Left field -->
          <ng-container *ngTemplateOutlet="fieldTpl; context: { $implicit: field }"></ng-container>
          <!-- Right field (next in array, if exists) -->
          <ng-container *ngIf="section.fields[i + 1] as nextField">
            <ng-container *ngTemplateOutlet="fieldTpl; context: { $implicit: nextField }"></ng-container>
          </ng-container>
        </div>

      </ng-container>
    </ng-container>
  </div>

  <!-- Field template -->
  <ng-template #fieldTpl let-field>

    <!-- Single Select -->
    <div class="standard-input" *ngIf="field.type === 'single-select'">
      <label>{{ field.label | translate }}</label>
      <select [(ngModel)]="values[field.key]">
        <option [ngValue]="undefined">{{ 'common.all' | translate }}</option>
        <option *ngFor="let opt of field.options" [value]="opt.value">
          {{ opt.label | translate }}
        </option>
      </select>
    </div>

    <!-- Multi Select -->
    <div class="standard-input" *ngIf="field.type === 'multi-select'">
      <label>{{ field.label | translate }}</label>
      <ui-form-field
        type="select"
        [multiple]="true"
        [searchable]="!!field.searchable"
        [searchPlaceholder]="'common.search' | translate"
        [options]="field.options || []"
        [ngModel]="values[field.key]"
        (ngModelChange)="values[field.key] = $event"
      ></ui-form-field>
    </div>

    <!-- Search -->
    <div class="standard-input" *ngIf="field.type === 'search'">
      <label>{{ field.label | translate }}</label>
      <input type="text"
             [(ngModel)]="values[field.key]"
             [placeholder]="(field.placeholder || '') | translate">
    </div>

    <!-- Range -->
    <div class="standard-input" *ngIf="field.type === 'range'">
      <label>{{ field.label | translate }}</label>
      <div class="min-max-row">
        <input type="number"
               [(ngModel)]="values[field.minKey!]"
               [placeholder]="(field.minPlaceholder || 'common.from') | translate">
        <input type="number"
               [(ngModel)]="values[field.maxKey!]"
               [placeholder]="(field.maxPlaceholder || 'common.to') | translate">
      </div>
    </div>

    <!-- Date Range -->
    <div class="standard-input filter-dates" *ngIf="field.type === 'date-range'">
      <label>{{ field.label | translate }}</label>
      <div class="date-range">
        <input type="date"
               [(ngModel)]="values[field.minKey!]"
               [placeholder]="(field.minPlaceholder || 'common.from') | translate">
        <input type="date"
               [(ngModel)]="values[field.maxKey!]"
               [placeholder]="(field.maxPlaceholder || 'common.to') | translate">
      </div>
    </div>

    <!-- Date Picker -->
    <div class="standard-input" *ngIf="field.type === 'date-picker'">
      <label>{{ field.label | translate }}</label>
      <input type="date"
             [(ngModel)]="values[field.key]"
             [placeholder]="(field.placeholder || '') | translate">
    </div>

    <!-- Radio -->
    <div class="standard-input" *ngIf="field.type === 'radio'">
      <label>{{ field.label | translate }}</label>
      <div class="radio-group">
        <label class="radio-option" *ngFor="let opt of field.options">
          <input type="radio"
                 [name]="field.key"
                 [value]="opt.value"
                 [(ngModel)]="values[field.key]">
          <span>{{ opt.label | translate }}</span>
        </label>
      </div>
    </div>

    <!-- Checkbox -->
    <div class="standard-input" *ngIf="field.type === 'checkbox'">
      <label>{{ field.label | translate }}</label>
      <div class="checkbox-group">
        <label class="checkbox-option" *ngFor="let opt of field.options">
          <input type="checkbox"
                 [checked]="isOptionSelected(field, opt.value)"
                 (change)="toggleMultiOption(field, opt.value)">
          <span>{{ opt.label | translate }}</span>
        </label>
      </div>
    </div>

    <!-- Button Selection -->
    <div class="standard-input" *ngIf="field.type === 'button-selection'">
      <label>{{ field.label | translate }}</label>
      <div class="btn-group">
        <button *ngFor="let opt of field.options"
                type="button"
                class="btn-option"
                [class.btn-option--active]="isOptionSelected(field, opt.value)"
                (click)="toggleMultiOption(field, opt.value)">
          {{ opt.label | translate }}
        </button>
      </div>
    </div>

    <!-- Autocomplete -->
    <div class="standard-input" *ngIf="field.type === 'autocomplete'">
      <label>{{ field.label | translate }}</label>
      <input type="text"
             [formControl]="autocompleteControls[field.key]"
             [matAutocomplete]="auto"
             [placeholder]="(field.placeholder || '') | translate">
      <mat-autocomplete #auto="matAutocomplete"
        [displayWith]="displayAutocompleteFn"
        (optionSelected)="onAutocompleteSelected(field, $event.option.value)">
        <mat-option *ngFor="let opt of autocompleteResults[field.key] | async" [value]="opt">
          {{ opt.label }}
        </mat-option>
      </mat-autocomplete>
    </div>

  </ng-template>
</app-shared-dialog>
